<script>
  import type { IUPicture } from "../../../core/types";
  import { UPicture } from "../../../core";

  interface IImagePanel {
    image: IUPicture;
    description: string;
  }

  export let data: IImagePanel;
</script>

<section class="image-panel g-centered">
  {#if data.image}
    <UPicture data={data.image} />
  {/if}

  {#if data.description}
    <div class="desc">
      {@html data.description}
    </div>
  {/if}
</section>

<style lang="scss">
  .image-panel {
    margin-bottom: 40px;
  }

  .desc {
    @include small;
    padding-top: 20px;
  }
</style>
